import { render, staticRenderFns } from "./SelectedServiceAreas.vue?vue&type=template&id=113bcfa4"
import script from "./SelectedServiceAreas.vue?vue&type=script&lang=ts"
export * from "./SelectedServiceAreas.vue?vue&type=script&lang=ts"
import style0 from "./SelectedServiceAreas.vue?vue&type=style&index=0&id=113bcfa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports